import { createGlobalStyle } from "styled-components";
import { palette, font } from "styled-theme";

const GlobalStyles = createGlobalStyle`
    .sidebar .sidebar-profile {
        padding-left: 1.55rem;
        padding-right: 2.2rem;
        height: 72px;
        background: #297BFF;
        font-size: 14px !important;
    }
    
    .sidebar .sidebar-profile img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-right: 8px;
    }

    .navbar .navbar-brand-wrapper .navbar-brand .lg-logo-image {
        max-width: 100%;
        height: 45px;
        margin: auto;
        vertical-align: middle;
    }
    
    .circle-color{
        width: 32px;
        height: 32px;
        border-radius: 50%;
    }
    
    .latest-status{
        font-size: 14px;
        display:flex;
        width: 100%;
    }
    
    .latest-status span{
        color: #828D99;
        font-size: 12px;
    }
    
    .vip-user{
        background-color: #2AD2C5;
        border-radius: 50%;
        width: 71.79px;
        height: 71.79px;
        display: flex;
        align-items: center;
        justify-content: center
    }
    
    .vip-user img{
        width: 85% !important;
        height: 85% !important;
    }

    img{
        object-fit: cover;
    }

    /* Override .table td img { border-radius: 100% } from style.css — show insurance logos uncropped */
    .table td img.insurance-company-table-logo,
    .jsgrid .jsgrid-table td img.insurance-company-table-logo {
        border-radius: 0;
        object-fit: contain;
    }

    .vip-user-card{
        background-color: #2AD2C5;
        border-radius: 50%;
        width: 170px;
        height: 170px;
        border: 11.42px solid #2AD2C5;
    }
    
    .normal-user-card{
        background-color: #F0FAF8;
        border-radius: 50%;
        width: 170px;
        height: 170px;
        border: 11.42px solid #F0FAF8;
    }
    
    .user-info{
        display: block;
        padding: 8px;
        font-size: 14px;
    }
    
    .user-info-label{
        margin-left: 10px;
        width: 23%;
        display: inline-block;
        color: #5C6B80;
    }
    
    .user-info-value{
        font-weight: bold;
        width: 70%;
        display: inline-block;
    }
    
    .user-card-title{
        background-color: #FFDB70;
        width: 38px;
        height: 38px;
        font-size: 11px;
        font-weight: 900;
        border-radius: 50%;
        padding: 5px;
        padding-top: 11px;
        color: #fff;
        position: absolute;
        margin-left: 6.6px;
        margin-top: -56px;
    }
    
    
    .has-search .form-control {
        padding-left: 2.375rem;
        margin: 5px;
    }
    
    .has-search .form-control-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 2.375rem;
        height: 2.375rem;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: #aaa;
        font-size: 29px;
        padding: 10px;
    }
    
    .add-items-btn{
        width: 160px;
        height: 45px;
        font-size: 16px;
        margin: 6px;
        margin-left: 19px;
        margin-right: -12px;
    }
    
    @media screen and (max-width: 740px) {
        .table-bar{
            display: block !important;
        }
    }
    
    .vip-bookmark{
        width: 20px;
        height: 73px;
        background-color: #2AD2C5;
        margin-left: 15.8px;
        margin-top: -10px;
    }
    
    .triangle-up {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 9px solid #fff;
        margin-left: 15.8px;
        margin-top: -9px;
    }
    
    .ant-modal-footer .ant-btn{
        border-radius: 20px;
        height: 33px;
    }
    
    .ant-modal-footer .ant-btn-primary{
        background-color: #297BFF;
    }
    
    .ant-modal-header {
        padding: 16px 24px;
        color: rgba(0, 0, 0, 0.85);
        background: #fff;
        border-bottom: 1px solid #f0f0f0;
        border-radius: 20px 20px 0 0 !important;
    }
    
    .ant-modal-content {
        border-radius: 20px !important;
    }

    .ant-form-item .ant-form-item-label{
        text-align: left;
        max-width: 160px;
        font-weight: bold;
        margin-right: 7px;
        white-space: normal;
    }

    .ant-form-item .ant-form-item-label > label {
        white-space: normal;
        height: auto;
    }

    .supplier-form-modal .ant-form-item-label,
    .ant-form-vertical .ant-form-item-label {
        max-width: 100%;
        width: 100%;
    }
    
    .ant-form-item .ant-input, .ant-select-selector, .ant-picker , .ant-input-password, .ant-input-number{
        border-radius: 5px !important;
        border-color: #99A0AA !important;
    }
    
    .ant-input-number{
        width: 100% !important;
    }
    
     .ant-form-item .ant-form-item-explain-error{
        font-size: 11px;
     }
    
    .upload-image-label{
        color: #2AD2C5;
        font-weight: 900;
        text-decoration: underline;
        cursor: pointer;
    }
   
    .ant-picker{
        min-width: 100%
    }
    
    .user-form-profile-image{
        margin: 0 auto;
        width: 200px;
        height: 200px;
    }
    
    .pillvery-tab-btn {
        text-align: center;
        width: 25%;
        margin-right: 0 !important;
        padding-right: 2px !important;
    }
    .pillvery-tab-btn-5 {
        width: 20%;
    }
    .pillvery-tab-btn-6 {
        width: 16%;
    }
    
    .category-image{
        width: 55px;
        height: 55px;
        border-radius: 6px;
        margin-right: 10px;
        display: inline-block;
        overflow: hidden;
    }
    .category-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        overflow: hidden;
    }
    
    .product-form-image{
        width: 170px;
        height: 170px;
    }
    
    .category-form-image{
        width: 150px;
        height: 150px;
        border: 1px solid #99a0aa;
    }
    
    .product-form-text-image{
        width: 170px;
        text-align: center;
    }
    
    .category-form-text-image{
        margin-left: 31px;
        width: 150px;
        text-align: center;
    }
    
    .pillvery-upload-image{
        cursor: pointer;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        border-radius: 9px;
    }
    .category-grid-image{
        width: 100%;
        height: 200px;
        border-radius: 6px;
        border: 2px solid #99A0AA;
    }
    
    .vertical-center-modal {
          text-align: center;
          white-space: nowrap;
    }
    
    .vertical-center-modal:before {
          content: '';
          display: inline-block;
          height: 100%;
          vertical-align: middle;
          width: 0;
    }
    
    .vertical-center-modal .ant-modal {
          display: inline-block;
          vertical-align: middle;
          top: 0;
          text-align: left;
    }
    
    .ant-form-item-children-icon{
        margin-top: -12px !important;
    }
    
    .pillvery-box-content{
        padding: 10px;
        background-color: #FAFAFA;
        overflow: scroll;
        height: 500px;
    }
    
    .category-card{
         color: #000000;
    }
     
    .category-card:hover, .card-active , .category-card:hover > .align-items-start .dropdown .btn i{
        background-color: #297BFF !important; 
        color: #ffffff !important;
    }

    .card-active .align-items-start .dropdown .btn i{
        color: #ffffff;
    }
    
   .category-card:hover .btn-outline-primary, .card-active .btn-outline-primary {
        color: #ffffff;
        border-color: #ffffff;
   }
    
   .category-card:hover .btn-outline-primary:hover {
        color: #297BFF;
        border-color: #ffffff;
        background-color: #ffffff;
   }
    
   .pillvery-submit-btn{
        border-radius: 26px !important;
        width: 102px;
        float: right;
        min-height: 44px;
        font-weight: bold !important;
   }
   
   .product-form .ant-form-item-control{
        max-width: 100%;
   }
   
   .pillvery-icon-card-primary{
        background: #2cd2c5;
        color: #ffffff !important;
   }
   
   .nav-pills-success .nav-link.active {
        background: #297BFF !important;
    }
    
   .nav-pills-success .nav-link {
       color: #5C6B80;
       background-color: #E7E9ED;
   }
   
    .nav-pills-success .nav-link:hover {
        background: #297BFF !important;
        color: #FFFFFF;
    }
    
    .header-order-card{
        background-color: #5C6B80;
        border-radius: 6px 6px 0 0;
        color: #ffffff;
    }
    
    .header-order-card b{
        font-size: 16px;
    }
    
    .total-order-value{
        background-color: #00D7EE1C;
    }
    
    .order-card-body div{
        margin-bottom: 7px;
    }
    
    .order-card-body .label{
        color: #21334D;
    }
     
   .order-card .value{
        font-weight: bold;
   }
    
   .pillvery-link{
       color: #2AD2C5;
   }
   .pillvery-text {
    color: #1890ff;
   }
   
   .pillvery-permissions-table .ant-form-item{
        max-height: 11px;
   }
   
   .ant-checkbox-checked .ant-checkbox-inner{
        background-color: #2AD2C5 !important;
        border-color: #2AD2C5 !important;
   }
   
   .supplier-chart {
        width: 80%;
        margin: 10px auto;
   }
   
   .body-supplier-info p{
        font-size: 19px;
        color: #4D4F5C;
   }
   
   .body-analytics-info{
        font-size: 12px;
        color: #4D4F5C;
   }
       
   .pillvery-search-input{
        border: 1px solid #99A0AA;
   }
   
   
   .pillvery-filter-select{
        border: 1px solid #E5E5E5;
   }
   
   .pillvery-border-radius{
        border-radius: 8px !important;
   }
   
   .pillvery-tab-btn a{
         border-radius: 5px !important;
   }
   
   .pillvery-sort-btn{
        width: 45px;
        margin-top: 5px;
        margin-right: 9px;
        font-size: 31px;
        padding: 2px;
        background-color: white;
        color: #5C6B80;
        border: 1px solid #8E96A2;
   }

   .sidebar .nav:not(.sub-menu) > .nav-item:hover > .nav-link {
        background: #F7F7FA !important;
        color: #297BFF !important;
        border-radius: 4px !important;
    }

    .sidebar .nav:not(.sub-menu) > .nav-item:hover > .nav-link .menu-title {
        font-weight: bold !important;
    }

    .sidebar .nav .nav-item.active > .nav-link i, .sidebar .nav .nav-item.active > .nav-link .menu-title, .sidebar .nav .nav-item.active > .nav-link .menu-arrow {
        color: #297BFF !important;
    }

    .sidebar .nav:not(.sub-menu) > .active > .nav-link {
        font-weight: bold !important;
    }

    .form-list-input input{
        min-width: 200px;
    }

    .ant-form-vertical .ant-form-item-label {
        padding: 0px !important;
        max-width: 100%;
    }
    
    .topbar-notifications .navbar-dropdown {
        height: 600px;
        overflow: scroll;
        min-width: 250px;
    }
    
    td{
        text-align: center;
    }
    
    .ant-upload-list-item-actions{
        background-color: #28d2c5;
        padding: 7px;
        border-radius: 10px;
    }
    
    .ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {
        opacity: 1;
        // margin-left: -42px;
    }
    
    .ant-upload-list-picture-card .ant-upload-list-item-error {
        border-color: #28d2c5;
    }
    
    .ant-upload-list-item-error .ant-upload-text-icon > .anticon,
    .ant-upload-list-item-error .ant-upload-list-item-name,
    .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon{
        color: green !important;
    }

    .cursor-pointer {
        cursor: pointer;
    }
    .print-visible {
        display: none;
    }
    .order-bar {
        width: calc(100% - 239px);
        left: auto;
    }
    @media screen and (max-width: 991px) {
        .order-bar {
            width: 100%;
            left: 0;
            right: 0;
        }
    }
    .order-item-card .order-item-name {
        flex: 1 1 0;
        min-width: 0;
        word-break: break-word;
        overflow-wrap: anywhere;
    }
    .order-item-card .order-item-actions {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        margin-top: 0.75rem;
        padding-left: calc(75px + 1.5rem);
    }
    .order-item-card .order-item-name .pillvery-text {
        white-space: normal;
    }
    .sidebar .profile-desc .name {
        white-space: normal;
        word-break: break-word;
        line-height: 1.25;
    }
    @media print {
        .print-order .print-visible {
            display: block;
        }
        .print-order a {
            text-decoration: none;
        }
        .print-order, .print-order .content-wrapper {
            overflow: visible;
            background: #FFF;
        }
        .print-order .order-item-card {
            break-inside: avoid;
        }
        .print-order .navbar, .print-order #sidebar, .print-order .footer, .print-hide {
            display: none !important;
        }
        .print-order .page-body-wrapper {
            padding: 0;
        }
        .print-order .main-panel {
            width: 100% !important;
        }
    }

    /* Matches consumer app: coral pill, white label, bottom-right on product image */
    .pillvery-near-expire-tag {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        background-color: #de5f75;
        color: #ffffff !important;
        font-size: 11px;
        font-weight: 600;
        line-height: 1.2;
        padding: 3px 9px;
        border-radius: 999px;
        letter-spacing: 0.02em;
        white-space: nowrap;
        font-family: inherit;
        border: none;
        vertical-align: middle;
    }

    .pillvery-near-expire-tag--overlay {
        position: absolute;
        bottom: 6px;
        right: 6px;
        z-index: 2;
        pointer-events: none;
        max-width: calc(100% - 10px);
        text-align: center;
    }

    /* Small product thumbnails (e.g. order line items ~75px) */
    .pillvery-near-expire-tag--overlay.pillvery-near-expire-tag--thumb {
        font-size: 9px;
        padding: 2px 6px;
        bottom: 3px;
        right: 3px;
        max-width: calc(100% - 6px);
    }
`;

export default GlobalStyles;
